export default __webpack_public_path__ + "static/1Ptvg83HX_SGhgqk3wotYKNnBQ-cec52f6ca748f677cff5a9f28f05592a.woff2";